import { useTranslation as useI18NextTranslation } from 'react-i18next'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { isRadiusUser } from '~/helpers/auth'

import { useAuthenticatedUser } from '~/hooks/useAuthentication'

import type { FlatNamespace, KeyPrefix } from 'i18next'
import type { UseTranslationOptions, FallbackNs } from 'react-i18next'

/**
 * Wrapper around react-i18next's `useTranslation` that enforces English
 * for operator (Radius) users while allowing customers to use their
 * preferred language from localStorage / browser detection.
 */
const useTranslation = <
  Ns extends FlatNamespace | Array<FlatNamespace> | undefined = undefined,
  KPrefix extends KeyPrefix<FallbackNs<Ns>> = undefined
>(
  ns?: Ns,
  options?: UseTranslationOptions<KPrefix>
) => {
  const [user] = useAuthenticatedUser()
  const isOperator = isRadiusUser(user)
  const { showLanguageSelector } = useFlags()

  return useI18NextTranslation(ns, {
    ...options,
    ...(showLanguageSelector && !isOperator ? {} : { lng: 'en' }),
  })
}

export default useTranslation
